import { Doctor } from "./doctor";
import { Location } from "./location.definition";
import { Patient } from "./patient";
import { RoleType } from "./user.definition";

export enum AppointmentStatus {
  CONFIRMED = "CONFIRMED",
  CANCELED = "CANCELED",
  COMPLETE = "COMPLETE",
  /**
   * Display-only: never sent by the API. A CONFIRMED appointment whose time has
   * passed shows as EXPIRED until the nightly job marks it COMPLETE
   * (see getDisplayStatus in utils/appointment-utils).
   */
  EXPIRED = "EXPIRED",
}
export enum AppointmentType {
  CLINIC = "CLINIC",
  HOME = "HOME",
  ONLINE = "ONLINE",
}

export enum AppointmentDate {
  UPCOMING = "UPCOMING",
  PAST = "PAST",
}

export interface BookedBy {
  email: string;
  firstName: string;
  lastName: string;
  photoUrl: string | null;
  roleName: RoleType;
}

export interface Appointment {
  id?: string;
  patientId: number;
  doctorId: number;
  doctor?: Doctor;
  patient?: Patient;
  appointmentTime: string;
  status: AppointmentStatus;
  appointmentType: AppointmentType;
  location: Location | Link;
  healthcareFacilityId: number;
  reason: string;
  department?: string;
  timeSlotId: number;
  bookedBy?: BookedBy;
}

export type Link = string;

export enum Country {
  CHAD = "CHAD",
  SENEGAL = "SENEGAL",
}
